var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-background"},[_c('img',{staticClass:"nav-logo",attrs:{"src":require("../../assets/logo_1.png")},on:{"click":_vm.irPantallaPrincipal}}),_c('img',{staticClass:"nav-logo-words",attrs:{"src":require("../../assets/logo_2.png")},on:{"click":_vm.irPantallaPrincipal}})])
}
var staticRenderFns = []

export { render, staticRenderFns }